import { checkValidity } from './inputFields';

const modals = document.querySelectorAll('.modal');
const subscriptionModal = document.querySelector('.subscription-modal');
const contactModal = document.querySelector('.contact-modal');
const openModal = document.getElementById('subscribeBtn');
const chatToggle = document.getElementById('chat-contact-toggle');
const modalSubmitBtn = document.getElementById('modalSubmitBtn');
const navbar = document.querySelector('#navbar');
const newsLetterForm = document.getElementById('newsLetterForm');
const newsLetterFormInput = newsLetterForm?.querySelector('[type="email"]');
const closeNewsLetterModal = document.querySelector('.closeNewsLetterModal');
let prevScrollpos = window.scrollY;

const setCookie = (name, value) => {
	const expirationDate = new Date();

	expirationDate.setDate(expirationDate.getDate() + 30); // Expires in 30 days

	document.cookie =
		name +
		'=' +
		encodeURIComponent(value) +
		'; expires=' +
		expirationDate.toUTCString() +
		'; path=/';
};

const getCookie = (name) => {
	const cookie = document.cookie
		.split('; ')
		.find((cookie) => cookie.startsWith(name + '='));

	return cookie ? true : null;
};

window.addEventListener('scroll', () => {
	const menu = document.getElementById('menu');
	const isMenuHidden = menu.classList.contains('hidden');
	let currentScrollPos = window.scrollY;
	if (currentScrollPos > prevScrollpos && currentScrollPos > 180) {
		if (isMenuHidden) navbar?.classList.add('-translate-y-full');
	} else {
		if (isMenuHidden) navbar?.classList.remove('-translate-y-full');
	}
	prevScrollpos = currentScrollPos;
});
window.addEventListener('load', () => {
	const isNewsletterSubscribed = localStorage.getItem('newsletterSubscribed');

	const isNewsletterCanceledByUser = getCookie('newsletterCanceled');

	if (
		isNewsletterCanceledByUser === null &&
		isNewsletterSubscribed === null &&
		subscriptionModal?.dataset['showModal']
	) {
		setTimeout(() => {
			if (subscriptionModal) subscriptionModal.style.display = 'block';
		}, 1000);
	}
});

if (modalSubmitBtn) {
	modalSubmitBtn.addEventListener('click', () => {
		if (newsLetterFormInput) {
			const isInputValid = checkValidity(newsLetterFormInput);
			if (isInputValid === true) {
				localStorage.setItem('newsletterSubscribed', true);
			}
		}
	});
}

if (closeNewsLetterModal) {
	closeNewsLetterModal.addEventListener('click', () => {
		setCookie('newsletterCanceled', true);
	});
}
if (openModal) {
	openModal.onclick = function () {
		if (subscriptionModal) subscriptionModal.style.display = 'block';
	};
}

function toggleSvgs(element) {
	const toggleSvg = element.querySelectorAll('svg');
	toggleSvg.forEach((svg) => {
		svg.classList.toggle('block');
		svg.classList.toggle('hidden');
	});
}
if (chatToggle) {
	chatToggle.onclick = function () {
		toggleSvgs(chatToggle);
		if (contactModal.style.display !== 'block')
			contactModal.style.display = 'block';
		else contactModal.style.display = 'none';
	};
	chatToggle?.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			contactModal.classList.toggle('hidden');
			toggleSvgs(chatToggle);
		}
	});
}

modals.forEach((modal) => {
	const closeBtns = modal.querySelectorAll('.closeButton');
	closeBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			modal.style.display = 'none';
		});
	});
});

window.onclick = function (event) {
	modals.forEach((modal) => {
		const background = modal.querySelector('#background');
		const contactBackground = modal.querySelector('#contact-background');

		if (event.target === modal || event.target === background) {
			if (event.target.getAttribute('data-newsletter') === 'true') {
				setCookie('newsletterCanceled', true);
			}
			modal.style.display = 'none';
		} else if (event.target === modal || event.target === contactBackground) {
			modal.style.display = 'none';
			toggleSvgs(chatToggle);
		}
	});
};

export default {
	modals: modals,
	subscriptionModal: subscriptionModal,
	openModal: openModal,
};
